
import { EnvType } from './adapters';

export const shareConfig: ShareDialogOptions = {
  title: '',
  desc: '',
  imgUrl: '',
  url: '',
  actName: '',
};

export const defaultConfig: shareConsructorOptions = {
  el: '.sharebtn',
  shareConfig,
  channels: ['wxt', 'wxf', 'qqf', 'qqz'],
  onShareShow: null,
  onShareClose: null,
  afterShare: null,
  // shareTo: null,
  options: {
    msdkicon: '',
    eventListener: 'click',
  },
  outgameTipsIcon:
    'https://tiem-cdn.qq.com/slugteam/slug-share/imgs/sharetips-outgame.png',
  // closeMenu() {
  //   if (typeof this.onShareClose === 'function') {
  //     this.onShareClose();
  //   }
  //   hideMenu();
  // },
  // showMenu() {
  //   if (typeof this.onShareShow === 'function') {
  //     this.onShareShow();
  //   }
  //   showMenu();
  // },
  setShareConfig: null,
  getChannels() {
    return this.channels || ['wxt', 'wxf', 'qqf', 'qqz'];
  },
  getOutgameTipsIcon() {
    return (
      this.outgameTipsIcon || 'https://tiem-cdn.qq.com/slugteam/slug-share/imgs/sharetips-outgame.png'
    );
  },
};

export const channelNames = {
  wxt: '朋友圈',
  wxf: '微信好友',
  qqf: 'QQ好友',
  qqz: 'QQ空间',
};

const regMSDKV3 = /msdkEncodeParam/;
const regMSDKV5 = /itopencodeparam/;

export const setEnvironment = (): EnvType => {
  // slugsdk
  if (window.navigator.userAgent.indexOf('TIEM Ingame Browser/') !== -1) {
    return (window.$jk || window.$micro) ? EnvType.JKMicro : EnvType.ItemSDK;
  }

  // msdk
  const token = location.search || sessionStorage.tokenParams;
  if (regMSDKV3.test(token)) {
    return EnvType.MSDK_V3;
  }
  if (regMSDKV5.test(token)) {
    return EnvType.MSDK_V5;
  }
  // if (window.navigator.userAgent.indexOf('MSDK') !== -1) {
  //   const token = location.search || sessionStorage.tokenParams;
  //   return /itopencodeparam/.test(token) ? EnvType.MSDK_V5 : EnvType.MSDK_V3;
  // }

  // outgame
  return EnvType.OutGame;
};

export const environment = setEnvironment();

const versionCompare = (str: string, target: string) => {
  if (!str || str.indexOf('.') === -1) {
    return false;
  }
  if (!target || target.indexOf('.') === -1) {
    return false;
  }
  const arr = str.split('.');
  const tagArr = target.split('.');
  let tag = true;
  arr.forEach((el: string, index: number) => {
    if (parseInt(el, 10) < parseInt(tagArr[index], 10)) {
      tag = false;
    }
  });
  return tag;
};

export const isHeightVersionMSDK = (): boolean => {
  const str = window.navigator.userAgent;
  if (str.indexOf('MSDK/') === -1) return false;
  let version = '';
  try {
    version = str.split('MSDK/')[1].split(' ')[0];
  } catch (e) {
    console.log(e);
  }
  return versionCompare(version, '3.3.11');
};

export const getBase64Img = (path: string) => new Promise<string>((resolve) => {
  const img = new Image();
  const extension = path.slice(path.lastIndexOf('.') + 1);
  img.src = path;
  img.setAttribute('crossOrigin', 'Anonymous');
  img.onload = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!!ctx) {
      ctx.drawImage(img, 0, 0);
      const dataUrl = canvas.toDataURL(`image/${extension}`);
      if (new Blob([dataUrl]).size <= 10240) resolve(dataUrl);
    }
    resolve(path);
  };
});
